import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { copy, detectLang, type Copy, type Lang } from '../data/i18n';
interface LanguageValue {
  lang: Lang;
  t: Copy;
  setLang: (lang: Lang) => void;
  toggleLang: () => void;
}
const STORAGE_KEY = 'pnm_lang';
const LanguageContext = createContext<LanguageValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  // Inglés por defecto; autodetección del navegador; y si el visitante
  // ya eligió un idioma, se respeta su elección.
  const [lang, setLangState] = useState<Lang>(() => {
    if (typeof window === 'undefined') return 'en';
    const saved = window.localStorage.getItem(STORAGE_KEY) as Lang | null;
    if (saved === 'en' || saved === 'es') return saved;
    return detectLang();
  });
  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* almacenamiento no disponible */
    }
  }, [lang]);
  const setLang = useCallback((next: Lang) => setLangState(next), []);
  const toggleLang = useCallback(() => setLangState(prev => prev === 'en' ? 'es' : 'en'), []);
  const value = useMemo<LanguageValue>(() => ({
    lang,
    t: copy[lang] as Copy,
    setLang,
    toggleLang
  }), [lang, setLang, toggleLang]);
  return <LanguageContext.Provider value={value} data-id="element-332" data-mp="32zbdjlusjgtc">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage debe usarse dentro de LanguageProvider');
  return ctx;
}